var be = Object.defineProperty, me = Object.defineProperties;
var ge = Object.getOwnPropertyDescriptors;
var F = Object.getOwnPropertySymbols;
var At = Object.prototype.hasOwnProperty, Pt = Object.prototype.propertyIsEnumerable;
var Et = (r, t, e) => t in r ? be(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, M = (r, t) => {
  for (var e in t || (t = {}))
    At.call(t, e) && Et(r, e, t[e]);
  if (F)
    for (var e of F(t))
      Pt.call(t, e) && Et(r, e, t[e]);
  return r;
}, Ut = (r, t) => me(r, ge(t));
var rt = (r, t) => {
  var e = {};
  for (var n in r)
    At.call(r, n) && t.indexOf(n) < 0 && (e[n] = r[n]);
  if (r != null && F)
    for (var n of F(r))
      t.indexOf(n) < 0 && Pt.call(r, n) && (e[n] = r[n]);
  return e;
};
var X, h, Gt, A, Tt, Jt, st, Kt, T = {}, Qt = [], Se = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, mt = Array.isArray;
function E(r, t) {
  for (var e in t)
    r[e] = t[e];
  return r;
}
function Xt(r) {
  var t = r.parentNode;
  t && t.removeChild(r);
}
function Ce(r, t, e) {
  var n, o, i, s = {};
  for (i in t)
    i == "key" ? n = t[i] : i == "ref" ? o = t[i] : s[i] = t[i];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? X.call(arguments, 2) : e), typeof r == "function" && r.defaultProps != null)
    for (i in r.defaultProps)
      s[i] === void 0 && (s[i] = r.defaultProps[i]);
  return q(r, s, n, o, null);
}
function q(r, t, e, n, o) {
  var i = { type: r, props: t, key: e, ref: n, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: o == null ? ++Gt : o, __i: -1, __u: 0 };
  return o == null && h.vnode != null && h.vnode(i), i;
}
function O(r) {
  return r.children;
}
function V(r, t) {
  this.props = r, this.context = t;
}
function P(r, t) {
  if (t == null)
    return r.__ ? P(r.__, r.__i + 1) : null;
  for (var e; t < r.__k.length; t++)
    if ((e = r.__k[t]) != null && e.__e != null)
      return e.__e;
  return typeof r.type == "function" ? P(r) : null;
}
function Zt(r) {
  var t, e;
  if ((r = r.__) != null && r.__c != null) {
    for (r.__e = r.__c.base = null, t = 0; t < r.__k.length; t++)
      if ((e = r.__k[t]) != null && e.__e != null) {
        r.__e = r.__c.base = e.__e;
        break;
      }
    return Zt(r);
  }
}
function ct(r) {
  (!r.__d && (r.__d = !0) && A.push(r) && !Q.__r++ || Tt !== h.debounceRendering) && ((Tt = h.debounceRendering) || Jt)(Q);
}
function Q() {
  var r, t, e, n, o, i, s, _, u;
  for (A.sort(st); r = A.shift(); )
    r.__d && (t = A.length, n = void 0, i = (o = (e = r).__v).__e, _ = [], u = [], (s = e.__P) && ((n = E({}, o)).__v = o.__v + 1, h.vnode && h.vnode(n), gt(s, n, o, e.__n, s.ownerSVGElement !== void 0, 32 & o.__u ? [i] : null, _, i == null ? P(o) : i, !!(32 & o.__u), u), n.__v = o.__v, n.__.__k[n.__i] = n, re(_, n, u), n.__e != i && Zt(n)), A.length > t && A.sort(st));
  Q.__r = 0;
}
function te(r, t, e, n, o, i, s, _, u, l, f) {
  var c, p, a, m, v, g = n && n.__k || Qt, y = t.length;
  for (e.__d = u, we(e, t, g), u = e.__d, c = 0; c < y; c++)
    (a = e.__k[c]) != null && typeof a != "boolean" && typeof a != "function" && (p = a.__i === -1 ? T : g[a.__i] || T, a.__i = c, gt(r, a, p, o, i, s, _, u, l, f), m = a.__e, a.ref && p.ref != a.ref && (p.ref && St(p.ref, null, a), f.push(a.ref, a.__c || m, a)), v == null && m != null && (v = m), 65536 & a.__u || p.__k === a.__k ? (m || p.__e != u || (u = P(p)), u = ee(a, u, r)) : typeof a.type == "function" && a.__d !== void 0 ? u = a.__d : m && (u = m.nextSibling), a.__d = void 0, a.__u &= -196609);
  e.__d = u, e.__e = v;
}
function we(r, t, e) {
  var n, o, i, s, _, u = t.length, l = e.length, f = l, c = 0;
  for (r.__k = [], n = 0; n < u; n++)
    s = n + c, (o = r.__k[n] = (o = t[n]) == null || typeof o == "boolean" || typeof o == "function" ? null : typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? q(null, o, null, null, null) : mt(o) ? q(O, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? q(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o) != null ? (o.__ = r, o.__b = r.__b + 1, _ = xe(o, e, s, f), o.__i = _, i = null, _ !== -1 && (f--, (i = e[_]) && (i.__u |= 131072)), i == null || i.__v === null ? (_ == -1 && c--, typeof o.type != "function" && (o.__u |= 65536)) : _ !== s && (_ === s + 1 ? c++ : _ > s ? f > u - s ? c += _ - s : c-- : _ < s ? _ == s - 1 && (c = _ - s) : c = 0, _ !== n + c && (o.__u |= 65536))) : (i = e[s]) && i.key == null && i.__e && !(131072 & i.__u) && (i.__e == r.__d && (r.__d = P(i)), _t(i, i, !1), e[s] = null, f--);
  if (f)
    for (n = 0; n < l; n++)
      (i = e[n]) != null && !(131072 & i.__u) && (i.__e == r.__d && (r.__d = P(i)), _t(i, i));
}
function ee(r, t, e) {
  var n, o;
  if (typeof r.type == "function") {
    for (n = r.__k, o = 0; n && o < n.length; o++)
      n[o] && (n[o].__ = r, t = ee(n[o], t, e));
    return t;
  }
  r.__e != t && (e.insertBefore(r.__e, t || null), t = r.__e);
  do
    t = t && t.nextSibling;
  while (t != null && t.nodeType === 8);
  return t;
}
function xe(r, t, e, n) {
  var o = r.key, i = r.type, s = e - 1, _ = e + 1, u = t[e];
  if (u === null || u && o == u.key && i === u.type && !(131072 & u.__u))
    return e;
  if (n > (u != null && !(131072 & u.__u) ? 1 : 0))
    for (; s >= 0 || _ < t.length; ) {
      if (s >= 0) {
        if ((u = t[s]) && !(131072 & u.__u) && o == u.key && i === u.type)
          return s;
        s--;
      }
      if (_ < t.length) {
        if ((u = t[_]) && !(131072 & u.__u) && o == u.key && i === u.type)
          return _;
        _++;
      }
    }
  return -1;
}
function $t(r, t, e) {
  t[0] === "-" ? r.setProperty(t, e == null ? "" : e) : r[t] = e == null ? "" : typeof e != "number" || Se.test(t) ? e : e + "px";
}
function N(r, t, e, n, o) {
  var i;
  t:
    if (t === "style")
      if (typeof e == "string")
        r.style.cssText = e;
      else {
        if (typeof n == "string" && (r.style.cssText = n = ""), n)
          for (t in n)
            e && t in e || $t(r.style, t, "");
        if (e)
          for (t in e)
            n && e[t] === n[t] || $t(r.style, t, e[t]);
      }
    else if (t[0] === "o" && t[1] === "n")
      i = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1")), t = t.toLowerCase() in r || t === "onFocusOut" || t === "onFocusIn" ? t.toLowerCase().slice(2) : t.slice(2), r.l || (r.l = {}), r.l[t + i] = e, e ? n ? e.u = n.u : (e.u = Date.now(), r.addEventListener(t, i ? Ht : Ot, i)) : r.removeEventListener(t, i ? Ht : Ot, i);
    else {
      if (o)
        t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t !== "rowSpan" && t !== "colSpan" && t !== "role" && t in r)
        try {
          r[t] = e == null ? "" : e;
          break t;
        } catch (s) {
        }
      typeof e == "function" || (e == null || e === !1 && t[4] !== "-" ? r.removeAttribute(t) : r.setAttribute(t, e));
    }
}
function Ot(r) {
  if (this.l) {
    var t = this.l[r.type + !1];
    if (r.t) {
      if (r.t <= t.u)
        return;
    } else
      r.t = Date.now();
    return t(h.event ? h.event(r) : r);
  }
}
function Ht(r) {
  if (this.l)
    return this.l[r.type + !0](h.event ? h.event(r) : r);
}
function gt(r, t, e, n, o, i, s, _, u, l) {
  var f, c, p, a, m, v, g, y, C, k, j, U, kt, D, et, w = t.type;
  if (t.constructor !== void 0)
    return null;
  128 & e.__u && (u = !!(32 & e.__u), i = [_ = t.__e = e.__e]), (f = h.__b) && f(t);
  t:
    if (typeof w == "function")
      try {
        if (y = t.props, C = (f = w.contextType) && n[f.__c], k = f ? C ? C.props.value : f.__ : n, e.__c ? g = (c = t.__c = e.__c).__ = c.__E : ("prototype" in w && w.prototype.render ? t.__c = c = new w(y, k) : (t.__c = c = new V(y, k), c.constructor = w, c.render = Ee), C && C.sub(c), c.props = y, c.state || (c.state = {}), c.context = k, c.__n = n, p = c.__d = !0, c.__h = [], c._sb = []), c.__s == null && (c.__s = c.state), w.getDerivedStateFromProps != null && (c.__s == c.state && (c.__s = E({}, c.__s)), E(c.__s, w.getDerivedStateFromProps(y, c.__s))), a = c.props, m = c.state, c.__v = t, p)
          w.getDerivedStateFromProps == null && c.componentWillMount != null && c.componentWillMount(), c.componentDidMount != null && c.__h.push(c.componentDidMount);
        else {
          if (w.getDerivedStateFromProps == null && y !== a && c.componentWillReceiveProps != null && c.componentWillReceiveProps(y, k), !c.__e && (c.shouldComponentUpdate != null && c.shouldComponentUpdate(y, c.__s, k) === !1 || t.__v === e.__v)) {
            for (t.__v !== e.__v && (c.props = y, c.state = c.__s, c.__d = !1), t.__e = e.__e, t.__k = e.__k, t.__k.forEach(function(I) {
              I && (I.__ = t);
            }), j = 0; j < c._sb.length; j++)
              c.__h.push(c._sb[j]);
            c._sb = [], c.__h.length && s.push(c);
            break t;
          }
          c.componentWillUpdate != null && c.componentWillUpdate(y, c.__s, k), c.componentDidUpdate != null && c.__h.push(function() {
            c.componentDidUpdate(a, m, v);
          });
        }
        if (c.context = k, c.props = y, c.__P = r, c.__e = !1, U = h.__r, kt = 0, "prototype" in w && w.prototype.render) {
          for (c.state = c.__s, c.__d = !1, U && U(t), f = c.render(c.props, c.state, c.context), D = 0; D < c._sb.length; D++)
            c.__h.push(c._sb[D]);
          c._sb = [];
        } else
          do
            c.__d = !1, U && U(t), f = c.render(c.props, c.state, c.context), c.state = c.__s;
          while (c.__d && ++kt < 25);
        c.state = c.__s, c.getChildContext != null && (n = E(E({}, n), c.getChildContext())), p || c.getSnapshotBeforeUpdate == null || (v = c.getSnapshotBeforeUpdate(a, m)), te(r, mt(et = f != null && f.type === O && f.key == null ? f.props.children : f) ? et : [et], t, e, n, o, i, s, _, u, l), c.base = t.__e, t.__u &= -161, c.__h.length && s.push(c), g && (c.__E = c.__ = null);
      } catch (I) {
        t.__v = null, u || i != null ? (t.__e = _, t.__u |= u ? 160 : 32, i[i.indexOf(_)] = null) : (t.__e = e.__e, t.__k = e.__k), h.__e(I, t, e);
      }
    else
      i == null && t.__v === e.__v ? (t.__k = e.__k, t.__e = e.__e) : t.__e = ke(e.__e, t, e, n, o, i, s, u, l);
  (f = h.diffed) && f(t);
}
function re(r, t, e) {
  t.__d = void 0;
  for (var n = 0; n < e.length; n++)
    St(e[n], e[++n], e[++n]);
  h.__c && h.__c(t, r), r.some(function(o) {
    try {
      r = o.__h, o.__h = [], r.some(function(i) {
        i.call(o);
      });
    } catch (i) {
      h.__e(i, o.__v);
    }
  });
}
function ke(r, t, e, n, o, i, s, _, u) {
  var l, f, c, p, a, m, v, g = e.props, y = t.props, C = t.type;
  if (C === "svg" && (o = !0), i != null) {
    for (l = 0; l < i.length; l++)
      if ((a = i[l]) && "setAttribute" in a == !!C && (C ? a.localName === C : a.nodeType === 3)) {
        r = a, i[l] = null;
        break;
      }
  }
  if (r == null) {
    if (C === null)
      return document.createTextNode(y);
    r = o ? document.createElementNS("http://www.w3.org/2000/svg", C) : document.createElement(C, y.is && y), i = null, _ = !1;
  }
  if (C === null)
    g === y || _ && r.data === y || (r.data = y);
  else {
    if (i = i && X.call(r.childNodes), g = e.props || T, !_ && i != null)
      for (g = {}, l = 0; l < r.attributes.length; l++)
        g[(a = r.attributes[l]).name] = a.value;
    for (l in g)
      a = g[l], l == "children" || (l == "dangerouslySetInnerHTML" ? c = a : l === "key" || l in y || N(r, l, null, a, o));
    for (l in y)
      a = y[l], l == "children" ? p = a : l == "dangerouslySetInnerHTML" ? f = a : l == "value" ? m = a : l == "checked" ? v = a : l === "key" || _ && typeof a != "function" || g[l] === a || N(r, l, a, g[l], o);
    if (f)
      _ || c && (f.__html === c.__html || f.__html === r.innerHTML) || (r.innerHTML = f.__html), t.__k = [];
    else if (c && (r.innerHTML = ""), te(r, mt(p) ? p : [p], t, e, n, o && C !== "foreignObject", i, s, i ? i[0] : e.__k && P(e, 0), _, u), i != null)
      for (l = i.length; l--; )
        i[l] != null && Xt(i[l]);
    _ || (l = "value", m !== void 0 && (m !== r[l] || C === "progress" && !m || C === "option" && m !== g[l]) && N(r, l, m, g[l], !1), l = "checked", v !== void 0 && v !== r[l] && N(r, l, v, g[l], !1));
  }
  return r;
}
function St(r, t, e) {
  try {
    typeof r == "function" ? r(t) : r.current = t;
  } catch (n) {
    h.__e(n, e);
  }
}
function _t(r, t, e) {
  var n, o;
  if (h.unmount && h.unmount(r), (n = r.ref) && (n.current && n.current !== r.__e || St(n, null, t)), (n = r.__c) != null) {
    if (n.componentWillUnmount)
      try {
        n.componentWillUnmount();
      } catch (i) {
        h.__e(i, t);
      }
    n.base = n.__P = null, r.__c = void 0;
  }
  if (n = r.__k)
    for (o = 0; o < n.length; o++)
      n[o] && _t(n[o], t, e || typeof r.type != "function");
  e || r.__e == null || Xt(r.__e), r.__ = r.__e = r.__d = void 0;
}
function Ee(r, t, e) {
  return this.constructor(r, e);
}
function Ae(r, t, e) {
  var n, o, i, s;
  h.__ && h.__(r, t), o = (n = typeof e == "function") ? null : e && e.__k || t.__k, i = [], s = [], gt(t, r = (!n && e || t).__k = Ce(O, null, [r]), o || T, T, t.ownerSVGElement !== void 0, !n && e ? [e] : o ? null : t.firstChild ? X.call(t.childNodes) : null, i, !n && e ? e : o ? o.__e : t.firstChild, n, s), re(i, r, s);
}
function Ct(r, t) {
  var e = { __c: t = "__cC" + Kt++, __: r, Consumer: function(n, o) {
    return n.children(o);
  }, Provider: function(n) {
    var o, i;
    return this.getChildContext || (o = [], (i = {})[t] = this, this.getChildContext = function() {
      return i;
    }, this.shouldComponentUpdate = function(s) {
      this.props.value !== s.value && o.some(function(_) {
        _.__e = !0, ct(_);
      });
    }, this.sub = function(s) {
      o.push(s);
      var _ = s.componentWillUnmount;
      s.componentWillUnmount = function() {
        o.splice(o.indexOf(s), 1), _ && _.call(s);
      };
    }), n.children;
  } };
  return e.Provider.__ = e.Consumer.contextType = e;
}
X = Qt.slice, h = { __e: function(r, t, e, n) {
  for (var o, i, s; t = t.__; )
    if ((o = t.__c) && !o.__)
      try {
        if ((i = o.constructor) && i.getDerivedStateFromError != null && (o.setState(i.getDerivedStateFromError(r)), s = o.__d), o.componentDidCatch != null && (o.componentDidCatch(r, n || {}), s = o.__d), s)
          return o.__E = o;
      } catch (_) {
        r = _;
      }
  throw r;
} }, Gt = 0, V.prototype.setState = function(r, t) {
  var e;
  e = this.__s != null && this.__s !== this.state ? this.__s : this.__s = E({}, this.state), typeof r == "function" && (r = r(E({}, e), this.props)), r && E(e, r), r != null && this.__v && (t && this._sb.push(t), ct(this));
}, V.prototype.forceUpdate = function(r) {
  this.__v && (this.__e = !0, r && this.__h.push(r), ct(this));
}, V.prototype.render = O, A = [], Jt = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, st = function(r, t) {
  return r.__v.__b - t.__v.__b;
}, Q.__r = 0, Kt = 0;
/*! js-cookie v3.0.5 | MIT */
function L(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t];
    for (var n in e)
      r[n] = e[n];
  }
  return r;
}
var Pe = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ut(r, t) {
  function e(o, i, s) {
    if (typeof document != "undefined") {
      s = L({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var _ = "";
      for (var u in s)
        s[u] && (_ += "; " + u, s[u] !== !0 && (_ += "=" + s[u].split(";")[0]));
      return document.cookie = o + "=" + r.write(i, o) + _;
    }
  }
  function n(o) {
    if (!(typeof document == "undefined" || arguments.length && !o)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], s = {}, _ = 0; _ < i.length; _++) {
        var u = i[_].split("="), l = u.slice(1).join("=");
        try {
          var f = decodeURIComponent(u[0]);
          if (s[f] = r.read(l, f), o === f)
            break;
        } catch (c) {
        }
      }
      return o ? s[o] : s;
    }
  }
  return Object.create(
    {
      set: e,
      get: n,
      remove: function(o, i) {
        e(
          o,
          "",
          L({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return ut(this.converter, L({}, this.attributes, o));
      },
      withConverter: function(o) {
        return ut(L({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var R = ut(Pe, { path: "/" }), lt = function(r, t) {
  return lt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }, lt(r, t);
};
function H(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  lt(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function at(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e)
    return e.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ft(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e)
    return r;
  var n = e.call(r), o, i = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; )
      i.push(o.value);
  } catch (_) {
    s = { error: _ };
  } finally {
    try {
      o && !o.done && (e = n.return) && e.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function pt(r, t, e) {
  if (e || arguments.length === 2)
    for (var n = 0, o = t.length, i; n < o; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return r.concat(i || Array.prototype.slice.call(t));
}
function x(r) {
  return typeof r == "function";
}
function ne(r) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, e = r(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var nt = ne(function(r) {
  return function(e) {
    r(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, o) {
      return o + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function dt(r, t) {
  if (r) {
    var e = r.indexOf(t);
    0 <= e && r.splice(e, 1);
  }
}
var Z = function() {
  function r(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return r.prototype.unsubscribe = function() {
    var t, e, n, o, i;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var _ = at(s), u = _.next(); !u.done; u = _.next()) {
              var l = u.value;
              l.remove(this);
            }
          } catch (v) {
            t = { error: v };
          } finally {
            try {
              u && !u.done && (e = _.return) && e.call(_);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          s.remove(this);
      var f = this.initialTeardown;
      if (x(f))
        try {
          f();
        } catch (v) {
          i = v instanceof nt ? v.errors : [v];
        }
      var c = this._finalizers;
      if (c) {
        this._finalizers = null;
        try {
          for (var p = at(c), a = p.next(); !a.done; a = p.next()) {
            var m = a.value;
            try {
              jt(m);
            } catch (v) {
              i = i != null ? i : [], v instanceof nt ? i = pt(pt([], ft(i)), ft(v.errors)) : i.push(v);
            }
          }
        } catch (v) {
          n = { error: v };
        } finally {
          try {
            a && !a.done && (o = p.return) && o.call(p);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (i)
        throw new nt(i);
    }
  }, r.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        jt(t);
      else {
        if (t instanceof r) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, r.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, r.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, r.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && dt(e, t);
  }, r.prototype.remove = function(t) {
    var e = this._finalizers;
    e && dt(e, t), t instanceof r && t._removeParent(this);
  }, r.EMPTY = function() {
    var t = new r();
    return t.closed = !0, t;
  }(), r;
}(), oe = Z.EMPTY;
function ie(r) {
  return r instanceof Z || r && "closed" in r && x(r.remove) && x(r.add) && x(r.unsubscribe);
}
function jt(r) {
  x(r) ? r() : r.unsubscribe();
}
var se = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, ce = {
  setTimeout: function(r, t) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    return setTimeout.apply(void 0, pt([r, t], ft(e)));
  },
  clearTimeout: function(r) {
    var t = ce.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(r);
  },
  delegate: void 0
};
function Ue(r) {
  ce.setTimeout(function() {
    throw r;
  });
}
function Dt() {
}
function Y(r) {
  r();
}
var wt = function(r) {
  H(t, r);
  function t(e) {
    var n = r.call(this) || this;
    return n.isStopped = !1, e ? (n.destination = e, ie(e) && e.add(n)) : n.destination = He, n;
  }
  return t.create = function(e, n, o) {
    return new ht(e, n, o);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Z), Te = Function.prototype.bind;
function ot(r, t) {
  return Te.call(r, t);
}
var $e = function() {
  function r(t) {
    this.partialObserver = t;
  }
  return r.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (n) {
        B(n);
      }
  }, r.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (n) {
        B(n);
      }
    else
      B(t);
  }, r.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        B(e);
      }
  }, r;
}(), ht = function(r) {
  H(t, r);
  function t(e, n, o) {
    var i = r.call(this) || this, s;
    if (x(e) || !e)
      s = {
        next: e != null ? e : void 0,
        error: n != null ? n : void 0,
        complete: o != null ? o : void 0
      };
    else {
      var _;
      i && se.useDeprecatedNextContext ? (_ = Object.create(e), _.unsubscribe = function() {
        return i.unsubscribe();
      }, s = {
        next: e.next && ot(e.next, _),
        error: e.error && ot(e.error, _),
        complete: e.complete && ot(e.complete, _)
      }) : s = e;
    }
    return i.destination = new $e(s), i;
  }
  return t;
}(wt);
function B(r) {
  Ue(r);
}
function Oe(r) {
  throw r;
}
var He = {
  closed: !0,
  next: Dt,
  error: Oe,
  complete: Dt
}, je = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function De(r) {
  return r;
}
function Ie(r) {
  return r.length === 0 ? De : r.length === 1 ? r[0] : function(e) {
    return r.reduce(function(n, o) {
      return o(n);
    }, e);
  };
}
var It = function() {
  function r(t) {
    t && (this._subscribe = t);
  }
  return r.prototype.lift = function(t) {
    var e = new r();
    return e.source = this, e.operator = t, e;
  }, r.prototype.subscribe = function(t, e, n) {
    var o = this, i = Me(t) ? t : new ht(t, e, n);
    return Y(function() {
      var s = o, _ = s.operator, u = s.source;
      i.add(_ ? _.call(i, u) : u ? o._subscribe(i) : o._trySubscribe(i));
    }), i;
  }, r.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, r.prototype.forEach = function(t, e) {
    var n = this;
    return e = Ft(e), new e(function(o, i) {
      var s = new ht({
        next: function(_) {
          try {
            t(_);
          } catch (u) {
            i(u), s.unsubscribe();
          }
        },
        error: i,
        complete: o
      });
      n.subscribe(s);
    });
  }, r.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, r.prototype[je] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return Ie(t)(this);
  }, r.prototype.toPromise = function(t) {
    var e = this;
    return t = Ft(t), new t(function(n, o) {
      var i;
      e.subscribe(function(s) {
        return i = s;
      }, function(s) {
        return o(s);
      }, function() {
        return n(i);
      });
    });
  }, r.create = function(t) {
    return new r(t);
  }, r;
}();
function Ft(r) {
  var t;
  return (t = r != null ? r : se.Promise) !== null && t !== void 0 ? t : Promise;
}
function Fe(r) {
  return r && x(r.next) && x(r.error) && x(r.complete);
}
function Me(r) {
  return r && r instanceof wt || Fe(r) && ie(r);
}
function Ne(r) {
  return x(r == null ? void 0 : r.lift);
}
function Le(r) {
  return function(t) {
    if (Ne(t))
      return t.lift(function(e) {
        try {
          return r(e, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Re(r, t, e, n, o) {
  return new Be(r, t, e, n, o);
}
var Be = function(r) {
  H(t, r);
  function t(e, n, o, i, s, _) {
    var u = r.call(this, e) || this;
    return u.onFinalize = s, u.shouldUnsubscribe = _, u._next = n ? function(l) {
      try {
        n(l);
      } catch (f) {
        e.error(f);
      }
    } : r.prototype._next, u._error = i ? function(l) {
      try {
        i(l);
      } catch (f) {
        e.error(f);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._error, u._complete = o ? function() {
      try {
        o();
      } catch (l) {
        e.error(l);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._complete, u;
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      r.prototype.unsubscribe.call(this), !n && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
    }
  }, t;
}(wt), We = ne(function(r) {
  return function() {
    r(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), _e = function(r) {
  H(t, r);
  function t() {
    var e = r.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return t.prototype.lift = function(e) {
    var n = new Mt(this, this);
    return n.operator = e, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new We();
  }, t.prototype.next = function(e) {
    var n = this;
    Y(function() {
      var o, i;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var s = at(n.currentObservers), _ = s.next(); !_.done; _ = s.next()) {
            var u = _.value;
            u.next(e);
          }
        } catch (l) {
          o = { error: l };
        } finally {
          try {
            _ && !_.done && (i = s.return) && i.call(s);
          } finally {
            if (o)
              throw o.error;
          }
        }
      }
    });
  }, t.prototype.error = function(e) {
    var n = this;
    Y(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = e;
        for (var o = n.observers; o.length; )
          o.shift().error(e);
      }
    });
  }, t.prototype.complete = function() {
    var e = this;
    Y(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var n = e.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), r.prototype._trySubscribe.call(this, e);
  }, t.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, t.prototype._innerSubscribe = function(e) {
    var n = this, o = this, i = o.hasError, s = o.isStopped, _ = o.observers;
    return i || s ? oe : (this.currentObservers = null, _.push(e), new Z(function() {
      n.currentObservers = null, dt(_, e);
    }));
  }, t.prototype._checkFinalizedStatuses = function(e) {
    var n = this, o = n.hasError, i = n.thrownError, s = n.isStopped;
    o ? e.error(i) : s && e.complete();
  }, t.prototype.asObservable = function() {
    var e = new It();
    return e.source = this, e;
  }, t.create = function(e, n) {
    return new Mt(e, n);
  }, t;
}(It), Mt = function(r) {
  H(t, r);
  function t(e, n) {
    var o = r.call(this) || this;
    return o.destination = e, o.source = n, o;
  }
  return t.prototype.next = function(e) {
    var n, o;
    (o = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || o === void 0 || o.call(n, e);
  }, t.prototype.error = function(e) {
    var n, o;
    (o = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || o === void 0 || o.call(n, e);
  }, t.prototype.complete = function() {
    var e, n;
    (n = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || n === void 0 || n.call(e);
  }, t.prototype._subscribe = function(e) {
    var n, o;
    return (o = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e)) !== null && o !== void 0 ? o : oe;
  }, t;
}(_e);
function ze(r, t) {
  return Le(function(e, n) {
    var o = 0;
    e.subscribe(Re(n, function(i) {
      return r.call(t, i, o++) && n.next(i);
    }));
  });
}
var $, b, it, Nt, vt = 0, ue = [], G = [], S = h, Lt = S.__b, Rt = S.__r, Bt = S.diffed, Wt = S.__c, zt = S.unmount, qt = S.__;
function xt(r, t) {
  S.__h && S.__h(b, r, vt || t), vt = 0;
  var e = b.__H || (b.__H = { __: [], __h: [] });
  return r >= e.__.length && e.__.push({ __V: G }), e.__[r];
}
function yt(r) {
  return vt = 1, qe(ae, r);
}
function qe(r, t, e) {
  var n = xt($++, 2);
  if (n.t = r, !n.__c && (n.__ = [e ? e(t) : ae(void 0, t), function(_) {
    var u = n.__N ? n.__N[0] : n.__[0], l = n.t(u, _);
    u !== l && (n.__N = [l, n.__[1]], n.__c.setState({}));
  }], n.__c = b, !b.u)) {
    var o = function(_, u, l) {
      if (!n.__c.__H)
        return !0;
      var f = n.__c.__H.__.filter(function(p) {
        return !!p.__c;
      });
      if (f.every(function(p) {
        return !p.__N;
      }))
        return !i || i.call(this, _, u, l);
      var c = !1;
      return f.forEach(function(p) {
        if (p.__N) {
          var a = p.__[0];
          p.__ = p.__N, p.__N = void 0, a !== p.__[0] && (c = !0);
        }
      }), !(!c && n.__c.props === _) && (!i || i.call(this, _, u, l));
    };
    b.u = !0;
    var i = b.shouldComponentUpdate, s = b.componentWillUpdate;
    b.componentWillUpdate = function(_, u, l) {
      if (this.__e) {
        var f = i;
        i = void 0, o(_, u, l), i = f;
      }
      s && s.call(this, _, u, l);
    }, b.shouldComponentUpdate = o;
  }
  return n.__N || n.__;
}
function Ve(r, t) {
  var e = xt($++, 3);
  !S.__s && Je(e.__H, t) && (e.__ = r, e.i = t, b.__H.__h.push(e));
}
function le(r) {
  var t = b.context[r.__c], e = xt($++, 9);
  return e.c = r, t ? (e.__ == null && (e.__ = !0, t.sub(b)), t.props.value) : r.__;
}
function Ye() {
  for (var r; r = ue.shift(); )
    if (r.__P && r.__H)
      try {
        r.__H.__h.forEach(J), r.__H.__h.forEach(bt), r.__H.__h = [];
      } catch (t) {
        r.__H.__h = [], S.__e(t, r.__v);
      }
}
S.__b = function(r) {
  b = null, Lt && Lt(r);
}, S.__ = function(r, t) {
  r && t.__k && t.__k.__m && (r.__m = t.__k.__m), qt && qt(r, t);
}, S.__r = function(r) {
  Rt && Rt(r), $ = 0;
  var t = (b = r.__c).__H;
  t && (it === b ? (t.__h = [], b.__h = [], t.__.forEach(function(e) {
    e.__N && (e.__ = e.__N), e.__V = G, e.__N = e.i = void 0;
  })) : (t.__h.forEach(J), t.__h.forEach(bt), t.__h = [], $ = 0)), it = b;
}, S.diffed = function(r) {
  Bt && Bt(r);
  var t = r.__c;
  t && t.__H && (t.__H.__h.length && (ue.push(t) !== 1 && Nt === S.requestAnimationFrame || ((Nt = S.requestAnimationFrame) || Ge)(Ye)), t.__H.__.forEach(function(e) {
    e.i && (e.__H = e.i), e.__V !== G && (e.__ = e.__V), e.i = void 0, e.__V = G;
  })), it = b = null;
}, S.__c = function(r, t) {
  t.some(function(e) {
    try {
      e.__h.forEach(J), e.__h = e.__h.filter(function(n) {
        return !n.__ || bt(n);
      });
    } catch (n) {
      t.some(function(o) {
        o.__h && (o.__h = []);
      }), t = [], S.__e(n, e.__v);
    }
  }), Wt && Wt(r, t);
}, S.unmount = function(r) {
  zt && zt(r);
  var t, e = r.__c;
  e && e.__H && (e.__H.__.forEach(function(n) {
    try {
      J(n);
    } catch (o) {
      t = o;
    }
  }), e.__H = void 0, t && S.__e(t, e.__v));
};
var Vt = typeof requestAnimationFrame == "function";
function Ge(r) {
  var t, e = function() {
    clearTimeout(n), Vt && cancelAnimationFrame(t), setTimeout(r);
  }, n = setTimeout(e, 100);
  Vt && (t = requestAnimationFrame(e));
}
function J(r) {
  var t = b, e = r.__c;
  typeof e == "function" && (r.__c = void 0, e()), b = t;
}
function bt(r) {
  var t = b;
  r.__c = r.__(), b = t;
}
function Je(r, t) {
  return !r || r.length !== t.length || t.some(function(e, n) {
    return e !== r[n];
  });
}
function ae(r, t) {
  return typeof t == "function" ? t(r) : t;
}
const K = (r, t) => {
  const e = /* @__PURE__ */ new Map();
  return r.forEach((n) => e.set(n, t.includes(n) ? "allow" : "deny")), e;
}, fe = (r) => Array.from(r).reduce((t, [e, n]) => n === "allow" ? [...t, e] : t, []), Ke = (r) => r.reduce((t, e) => (t.set(e, "allow"), t), /* @__PURE__ */ new Map());
var Qe = 0;
function d(r, t, e, n, o, i) {
  var s, _, u = {};
  for (_ in t)
    _ == "ref" ? s = t[_] : u[_] = t[_];
  var l = { type: r, props: u, key: e, ref: s, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --Qe, __i: -1, __u: 0, __source: o, __self: i };
  if (typeof r == "function" && (s = r.defaultProps))
    for (_ in s)
      u[_] === void 0 && (u[_] = s[_]);
  return h.vnode && h.vnode(l), l;
}
const pe = Ct({}), Xe = ({
  customStyles: r,
  children: t
}) => d(pe.Provider, {
  value: r,
  children: t
});
function Ze(r) {
  const t = le(pe);
  if (!t || !("classNames" in t))
    return {};
  const {
    classNames: e
  } = t;
  return e === void 0 || r === void 0 || !("location" in e) ? e : e[r];
}
function tr(r, t, e, n) {
  return [...(Array.isArray(t) ? t : [t]).flatMap((i) => n != null && n.includes(i) ? [] : [`cc-${i}`, r[i]]), e].flat().filter(Boolean).join(" ");
}
function tt(r) {
  const t = Ze(), e = (n) => t[n];
  return (n) => {
    const o = Array.isArray(n) ? n.map((i) => e(i)) : [e(n)];
    return tr(r, n, o.filter((i) => typeof i == "string"), Object.keys(t));
  };
}
const er = "_button_1rlej_1", rr = {
  button: er,
  "button-primary": "_button-primary_1rlej_15",
  "button-secondary": "_button-secondary_1rlej_20"
}, W = (n) => {
  var o = n, {
    priority: r = "secondary",
    children: t
  } = o, e = rt(o, [
    "priority",
    "children"
  ]);
  const i = tt(rr);
  return d("button", Ut(M({}, e), {
    className: i(["button", `button-${r}`]),
    children: t
  }));
}, nr = {
  "button-set": "_button-set_1it6l_1"
}, or = ({
  children: r
}) => {
  const t = tt(nr);
  return d("div", {
    className: t("button-set"),
    children: r
  });
}, ir = "_list_1ocrb_1", sr = {
  list: ir,
  "list-item": "_list-item_1ocrb_8",
  "list-title": "_list-title_1ocrb_14",
  "list-description": "_list-description_1ocrb_19",
  "list-checkbox": "_list-checkbox_1ocrb_24"
}, cr = ({
  categories: r,
  consent: t,
  onChange: e
}) => {
  const n = tt(sr);
  return d("ul", {
    className: n("list"),
    children: r.map((o) => {
      const i = o.id === "necessary";
      return d("li", {
        className: n("list-item"),
        children: [d("input", {
          type: "checkbox",
          id: o.id,
          className: n("list-checkbox"),
          checked: i || t.includes(o.id),
          disabled: i,
          onChange: () => {
            if (i)
              return;
            const s = t.includes(o.id) ? t.filter((_) => _ !== o.id) : [...t, o.id];
            return e(s);
          }
        }), d("div", {
          children: [d("label", {
            for: o.id,
            className: n("list-title"),
            children: o.title
          }), d("p", {
            className: n("list-description"),
            children: o.description
          })]
        })]
      }, o.id);
    })
  });
}, de = Ct(/* @__PURE__ */ new Map()), _r = ({
  events: r,
  defaultConsent: t,
  children: e
}) => {
  const [n, o] = yt(t);
  return Ve(() => {
    const i = r.subscribe((s) => {
      s.type === "consent-updated" && o(s.details);
    });
    return () => i.unsubscribe();
  }, [r]), d(de.Provider, {
    value: n,
    children: e
  });
}, ur = () => le(de), he = {
  accept: "Accept",
  configure: "Configure",
  deny: "Only necessary",
  acceptSelected: "Accept Selected"
}, ve = Ct(he), lr = ({
  strings: r,
  children: t
}) => d(ve.Provider, {
  value: M(M({}, he), r),
  children: t
}), z = ({
  id: r
}) => d(ve.Consumer, {
  children: (t) => t[r]
}), ar = "_box_1rs3p_1", fr = {
  box: ar
}, pr = ({
  heading: r,
  message: t,
  categories: e,
  onConsent: n
}) => {
  const [o, i] = yt(!1), s = tt(fr), _ = ur(), [u, l] = yt(fe(_)), f = e.map(({
    id: g
  }) => g), c = () => {
    n(K(f, f)), i(!1);
  }, p = () => {
    n(K(f, ["necessary", ...u])), i(!1);
  }, a = () => {
    n(K(f, ["necessary"])), i(!1);
  }, v = t.trim().startsWith("<p") ? d("div", {
    class: s("message"),
    dangerouslySetInnerHTML: {
      __html: t
    }
  }) : d("p", {
    class: s("message"),
    dangerouslySetInnerHTML: {
      __html: t
    }
  });
  return d("div", {
    class: s("box"),
    children: [r && d("h1", {
      class: s("heading"),
      children: r
    }), v, !o && d(or, {
      children: [d(W, {
        onClick: c,
        priority: "primary",
        children: d(z, {
          id: "accept"
        })
      }), d(W, {
        onClick: () => i((g) => !g),
        children: d(z, {
          id: "configure"
        })
      }), d(W, {
        onClick: a,
        children: d(z, {
          id: "deny"
        })
      })]
    }), o && d(O, {
      children: [d(cr, {
        categories: e,
        consent: u,
        onChange: l
      }), d(W, {
        onClick: p,
        priority: "primary",
        children: d(z, {
          id: "acceptSelected"
        })
      })]
    })]
  });
};
class hr {
  constructor(t) {
    this.version = "1", this.element = document.createElement("div"), this.events = new _e(), this.extensions = [], this.handleConsent = (s) => {
      this.events.next({
        type: "consent-updated",
        details: s
      }), this.close();
    };
    const i = t, {
      extensions: e
    } = i, n = rt(i, [
      "extensions"
    ]);
    this.settings = n, this.extensions = e, this.extensions.forEach((s) => s.init(this)), this.renderUI();
    const o = this.readCookie();
    o && o.size > 0 ? this.events.next({
      type: "consent-updated",
      details: o
    }) : this.open(), document.querySelectorAll("[data-cc-open]").forEach((s) => {
      s.addEventListener("click", () => this.open());
    }), this.events.pipe(ze((s) => s.type === "consent-updated")).subscribe((s) => this.writeCookie(s.details));
  }
  subscribe(t) {
    return this.events.subscribe(t);
  }
  extend(t) {
    t.init(this), this.extensions.push(t);
  }
  open() {
    document.body.appendChild(this.element);
  }
  close() {
    document.body.removeChild(this.element);
  }
  renderUI() {
    Ae(d(lr, {
      strings: this.settings.strings,
      children: d(Xe, {
        customStyles: this.settings.styles || {},
        children: d(_r, {
          events: this.events,
          defaultConsent: this.readCookie() || this.getDefaultConsent(),
          children: d(pr, {
            heading: this.settings.heading,
            message: this.settings.message,
            categories: this.settings.categories,
            onConsent: this.handleConsent
          })
        })
      })
    }), this.element);
  }
  readCookie() {
    const t = R.get("cc-version"), e = R.get("cc-details");
    if (t !== this.version || typeof e != "string")
      return;
    const n = JSON.parse(e);
    return !Array.isArray(n) || n.some((i) => typeof i != "string") ? void 0 : Ke(n);
  }
  writeCookie(t) {
    const e = fe(t);
    R.set("cc-version", this.version, {
      expires: 365,
      sameSite: "strict"
    }), R.set("cc-details", JSON.stringify(e), {
      expires: 365,
      sameSite: "strict"
    });
  }
  getDefaultConsent() {
    return K(this.settings.categories.map(({
      id: t
    }) => t), ["necessary"]);
  }
}
class ye {
  init(t) {
    this.consent = t, this.apply();
  }
}
class vr extends ye {
  constructor(t) {
    super(), this.settings = t, globalThis.dataLayer = globalThis.dataLayer || [];
  }
  apply() {
    var t;
    this.sendDefault(), (t = this.consent) == null || t.subscribe((e) => {
      e.type === "consent-updated" && this.sendUpdate(e.details);
    });
  }
  sendDefault() {
    this.gtag("consent", "default", {
      ad_user_data: "denied",
      ad_personalization: "denied",
      ad_storage: "denied",
      analytics_storage: "denied",
      wait_for_update: 500
    });
  }
  sendUpdate(t) {
    const e = this.settings.categories, n = (o) => o && t.has(o) && t.get(o) === "allow" ? "granted" : "denied";
    this.gtag("consent", "update", {
      ad_user_data: n(e == null ? void 0 : e.ad_user_data),
      ad_personalization: n(e == null ? void 0 : e.ad_personalization),
      ad_storage: n(e == null ? void 0 : e.ad_storage),
      analytics_storage: n(e == null ? void 0 : e.analytics_storage),
      wait_for_update: 500
    });
  }
  gtag(...t) {
    dataLayer == null || dataLayer.push(t);
  }
}
const Yt = (r) => r === "necessary" || r === "statistics" || r === "marketing";
class yr extends ye {
  constructor() {
    super(...arguments), this.createScript = (t) => {
      const e = document.createElement("script");
      return ["src", "async", "crossorigin", "defer", "integrity", "nonce", "referrerpolicy"].forEach((n) => {
        if (t.hasAttribute(n)) {
          const o = t.getAttribute(n);
          e.setAttribute(n, o || "");
        }
      }), t.hasAttribute("data-src") && e.setAttribute("src", t.getAttribute("data-src") || ""), t.text && (e.text = t.text), e;
    };
  }
  apply() {
    var t;
    (t = this.consent) == null || t.subscribe((e) => {
      e.type === "consent-updated" && this.update(e.details);
    });
  }
  update(t) {
    this.updateImages(t), this.updateScripts(t);
  }
  /**
   * Update all images that have a `data-cc-category` attribute. If the consent
   * for the category is `allow`, the image will be loaded.
   */
  updateImages(t) {
    document.querySelectorAll("img[data-cc-category]").forEach((n) => {
      var i;
      const o = n.getAttribute("data-cc-category");
      Yt(o) && t.get(o) === "allow" && (n.setAttribute("src", n.getAttribute("data-cc-src") || ""), (i = this.consent) == null || i.events.next({
        type: "image-loaded",
        details: {
          src: n.src,
          id: n.id
        }
      }));
    });
  }
  /**
   * Update all scripts that have a `data-cc-category` attribute. If the consent
   * for the category is `allow`, the script will be loaded.
   */
  updateScripts(t) {
    document.querySelectorAll("script[data-cc-category]").forEach((n) => {
      var i;
      const o = n.getAttribute("data-cc-category");
      Yt(o) && t.get(o) === "allow" && (this.appendScript(n), (i = this.consent) == null || i.events.next({
        type: "script-loaded",
        details: {
          src: n.src,
          id: n.id
        }
      }));
    });
  }
  /**
   * Append a script element to the DOM. This will trigger the script to load.
   */
  appendScript(t) {
    var n;
    const e = this.createScript(t);
    (n = t.parentNode) == null || n.replaceChild(e, t);
  }
}
export {
  vr as ConsentMode,
  hr as CookieConsent,
  yr as DataAttributes
};
